/* global globalThis */
export const API_BASE_URL = globalThis?.API_BASE_URL;
export const STREAM_LIT_URL = globalThis?.STREAM_LIT_URL;
export const META_TAG_URL = globalThis?.META_TAG_URL;
export const IS_GT_ENABLED = globalThis?.IS_GT_ENABLED;
export const IS_OPENSOURCE_VOICE_KIT_ENABLED =
  globalThis?.IS_OPENSOURCE_VOICE_KIT_ENABLED;
export const ACTIVE_VOICE_KIT_NAME = globalThis?.ACTIVE_VOICE_KIT_NAME;
export const VOICE_AGENT_GENDER = globalThis?.VOICE_AGENT_GENDER;
export const IS_TALK_TO_ME_ENABLED = globalThis?.IS_TALK_TO_ME_ENABLED;
